import { apolloClient } from '@/apollo';
import { CurrentUserDocument, CurrentUserQuery } from '../use-current-user/graphql.generated';
import { calculateRouteOptions } from './common';

export const getPossibleRoutes = async () => {
	const result = await apolloClient.query<CurrentUserQuery>({
		query: CurrentUserDocument,
	});

	return calculateRouteOptions(result.data?.currentUser?.roles ?? []);
};
